"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { db } from "@/lib/db";
import type { AiProfile } from "@/types/ai";
import { useLoadingData } from "@/lib/hooks/useLoadingData";
import ProjectsList from "@/components/projects/ProjectsList";

export const dynamic = "force-dynamic";

async function loadProfile(): Promise<AiProfile | null> {
  const profiles = await db.aiProfiles.orderBy("createdAt").reverse().limit(1).toArray();
  return profiles[0] ?? null;
}

export default function ProjectsPage() {
  const router = useRouter();
  const { data: profile, loading, error } = useLoadingData(loadProfile);

  useEffect(() => {
    if (loading || profile) return;
    if (error) console.error("Failed to load profile:", error);
    router.push("/onboarding");
  }, [loading, profile, error, router]);

  if (loading) {
    return (
      <div className="min-h-screen gradient-bg flex items-center justify-center pb-20">
        <div className="text-white/80">Loading...</div>
      </div>
    );
  }
  if (!profile) return null;

  return <ProjectsList profile={profile} />;
}

